const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:8080';

export async function apiFetch<T = unknown>(
  path: string,
  init: RequestInit = {},
  token?: string,
): Promise<T> {
  const headers = new Headers(init.headers);
  // Only declare a JSON body when one's actually being sent. Otherwise
  // Fastify's strict JSON parser rejects with FST_ERR_CTP_EMPTY_JSON_BODY
  // on bodyless requests like DELETE (the content-type says "I'm
  // sending JSON" but the body is empty).
  if (init.body != null) {
    headers.set('content-type', 'application/json');
  }
  if (token) headers.set('authorization', `Bearer ${token}`);

  const res = await fetch(`${baseUrl}${path}`, { ...init, headers });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`API ${res.status}: ${body}`);
  }
  return res.json() as Promise<T>;
}

export const API_BASE_URL = baseUrl;
